import React, { Component } from 'react';

import { FieldArray } from 'redux-form';

import CotenantsFormFields from 'components/shared/CotenantsFormFields';
import Header from 'components/shared/Header';
import { getTranslatedString } from 'helpers/i18n';

let LeaseHoldersFieldArray = class extends Component {
  render() {
    return (
      <div className="row">
        <Header name={getTranslatedString('landlordPortal.leaseHoldersFieldArray.title')} />

        <div className="row" style={{ padding: '0 15px' }}>
          {this._renderFieldArray()}
        </div>
      </div>
    );
  }

  _renderFieldArray = () => {
    if (this.props.deleteCotenant === undefined) {
      return (
        <FieldArray
          name="cotenants"
          component={CotenantsFormFields}
          initialFields
          disabled={this.props.disabled}
        />
      );
    }

    return (
      <FieldArray
        name="cotenants"
        component={CotenantsFormFields}
        onDelete={cotenantID => this.props.deleteCotenant(cotenantID)}
        onDeleteError={() =>
          this.props.showFailure(
            getTranslatedString('landlordPortal.leaseHoldersFieldArray.oneCotenantWarning')
          )}
        initialFields
        disabled={this.props.disabled}
        enableAddAndRemove={this.props.enableAddAndRemove}
      />
    );
  };
};

export default LeaseHoldersFieldArray;
